import React from 'react';
import { zoomTableActionsConfig } from '../../commons/zoomTable/zoomTableConfig';
import { RenderRetailTableActionButtons } from '../../commons/tableActionButton/tableActionButton';
import styles from './addressFloorTagging.scss';

export const addressFloorTaggingTableConfig = {
  columns: [
    {
      Header: 'Pick/Delivery',
      headerClassName: 'zt-custom-th flex-10',
      sortable: false,
      className: 'zt-custom-td flex-10',
      Cell: row => (
        <div className="l-row a-center">
          {row.original.pickupOrDrsId || '-'}
        </div>
      )
    },
    {
      Header: 'Client',
      headerClassName: 'zt-custom-th flex-15',
      className: 'zt-custom-td flex-15',
      sortable: false,
      Cell: row => <div>{row.original.clientName || '-'}</div>
    },
    {
      Header: () => <div>Activity Type</div>,
      headerClassName: 'flex-15 zt-custom-th',
      className: 'zt-custom-td flex-15',
      sortable: false,
      Cell: row => <div>{row.original.activityType || '-'}</div>
    },
    {
      Header: 'Address',
      headerClassName: 'flex-25 zt-custom-th',
      className: 'zt-custom-td flex-25',
      sortable: false,
      Cell: row => (
        <div className={styles.address}>
          {row.original.clientAddress || '-'}
        </div>
      )
    },
    {
      Header: 'Phone No',
      headerClassName: 'flex-10 zt-custom-th',
      className: 'zt-custom-td flex-10',
      sortable: false,
      Cell: row => (
        <div className={styles.address}>
          {row.original.clientMobileNumber || '-'}
        </div>
      )
    },
    {
      Header: 'Floor No',
      headerClassName: 'flex-10 zt-custom-th',
      className: 'zt-custom-td flex-10',
      sortable: false,
      Cell: row => (
        <div className={styles.address}>
          {row.original.floorNumber !== null ? row.original.floorNumber : '-'}
        </div>
      )
    },
    {
      Header: 'Action',
      headerClassName: 'flex-25 zt-custom-th',
      className: 'flex-25',
      sortable: false,
      Cell: obj => (
        <RenderRetailTableActionButtons
          rowData={obj.original || {}}
          buttonConfig={zoomTableActionsConfig.ADDRESS_FLOOR_TAGGING.buttons}
        />
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No tasks found',
  style: { maxHeight: 'calc(100vh - 21rem)' }
};

export const addressFloorTaggingTableActionConfig = {
  buttons: [
    {
      label: 'APPROVE',
      labelOnly: true,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.ADDRESS_FLOOR_TAGGING.actions &&
          zoomTableActionsConfig.ADDRESS_FLOOR_TAGGING.actions.approveTask
        ) {
          zoomTableActionsConfig.ADDRESS_FLOOR_TAGGING.actions.approveTask(
            rowData
          );
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0 0.5rem'
      }
    },
    {
      label: 'REJECT',
      labelOnly: true,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.ADDRESS_FLOOR_TAGGING.actions &&
          zoomTableActionsConfig.ADDRESS_FLOOR_TAGGING.actions.rejectTask
        ) {
          zoomTableActionsConfig.ADDRESS_FLOOR_TAGGING.actions.rejectTask(
            rowData
          );
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0 0.5rem'
      }
    }
  ]
};
